import { sha256 } from 'js-sha256';
import { isFilterId } from '@jira/issue-navigator__actions-common/src/utils/filters/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import type { RouterContext } from '@atlassian/react-resource-router';

export const getResourceKey = (
	baseKey: string,
	{
		match: {
			params: { projectKey },
		},
		query: { filter, jql },
	}: RouterContext,
): string => {
	if (projectKey) {
		return `${baseKey}-${projectKey}`;
	}

	const filterId = Boolean(filter) && isFilterId(filter) ? filter : null;

	if (filterId) {
		return `${baseKey}-${filterId}`;
	}

	const normalizedJql = (jql ?? '').trim();
	if (normalizedJql) {
		return `${baseKey}-jql-${sha256(normalizedJql)}`;
	}

	return baseKey;
};

const getProjectViewResourceKeySuffix = ({
	match: {
		params: { navigationItemId, projectKey },
	},
}: RouterContext): string => {
	if (!projectKey || !navigationItemId || !expVal('saved_list_view', 'isEnabled', false)) {
		return '';
	}

	return `-navigation-item-${navigationItemId}`;
};

export const getIssueSearchResourceKey = (routerContext: RouterContext): string =>
	`${getResourceKey(
		'issue-navigator-relay',
		routerContext,
	)}${getProjectViewResourceKeySuffix(routerContext)}`;
